import React from 'react';
import { Heading, Text } from '@chakra-ui/react';
import { getClient } from '../../libs/sanity.client';
import { indexQuery, Post } from '../../libs/sanity.queries';
import Page from '../../components/Page';
import MoreStories from '../../components/Post/MoreStories';
import HeroPost from '../../components/Post/HeroPost';

export default function ProjectSlugRoute({ heroPost, morePosts }: { heroPost: Post; morePosts: Post[] }) {
  return (
    <Page
      seoOptions={{
        title: 'SmartParse Articles and Resources',
        description:
          'Gain insights and best practices through expert articles on efficient data migration and API integration with SmartParse.',
        canonical: `https://smartparse.io/posts/`
      }}
      maxW='6xl'
      px={10}
      my={{ base: 6, md: 20 }}
      mx='auto'
    >
      <Heading as='h1' size={{ base: 'md', md: '2xl' }} mb={{ base: 10, md: 20 }} fontWeight='extrabold'>
        Articles &amp; Resources
        <Text as='span' color='accent'>
          .
        </Text>
      </Heading>

      {heroPost && (
        <HeroPost
          title={heroPost.title}
          coverImage={heroPost.mainImage}
          date={heroPost.date}
          author={heroPost.author}
          slug={heroPost.slug}
          excerpt={heroPost.description}
        />
      )}
      {morePosts.length > 0 && <MoreStories posts={morePosts} />}
    </Page>
  );
}

// This also gets called at build time
export const getStaticProps = async () => {
  const [heroPost, ...morePosts] = await getClient().fetch(indexQuery);

  return { props: { heroPost, morePosts } };
};
